import React from "react"
import PropTypes from "prop-types"
import { connect, useSelector } from "react-redux"
import L10n from "lib/carrot-l10n"
import { getCountryCode } from "reducers/companyInfo"
import ProviderFinderLayout, { LocationLink } from "components/views/providerfinder/ProviderFinderLayout"
import ProvidersByCountry from "content/Providers"
import { CountryMap } from "content/CountryMap"
import { MultiColumnLayout } from "./ProviderFinderLayout"
import { H4 } from "@carrotfertility/carotene"
import { BodyLarge } from "../atoms/Bodies"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { ProviderFinderSideBar } from "components/views/providerfinder/SideBar"
import { getBenefitConfiguration } from "reducers/benefitConfiguration"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

LocationLink.propTypes = {
  name: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired
}

const Subsection = ({ country, countryProviderData }) => {
  const headerAndLinks = []
  headerAndLinks.push(
    <div key={country} className="mt3 column-span pb35">
      <H4>{country}</H4>
    </div>
  )
  Object.keys(countryProviderData).forEach((subRegion) => {
    headerAndLinks.push(
      <LocationLink key={country + subRegion} name={subRegion} to={`/providerfinder/${country}/${subRegion}`} />
    )
  })
  return headerAndLinks
}

const Main = ({ countryCode }) => {
  const country = CountryMap[countryCode]
  const countryProviderData = ProvidersByCountry[country]
  let errorFindingProviders = false
  const {
    featureConfig: { isCarrotRxEnabled: isCarrotRxCompany }
  } = useSelector(getBenefitConfiguration)

  if (!countryProviderData) {
    errorFindingProviders = true
  }

  return (
    <div>
      <div>
        <div className="pb4-l pb3">
          <BodyLarge color="black-80">Choose from this list of eligible providers.</BodyLarge>
        </div>
        {errorFindingProviders ? (
          <div>
            <p className="pb3">
              {l`We’re adding new providers all the time, so `} <a href="/talk-to-carrot">contact us</a>&nbsp;
              {l`and we’ll help you connect to the provider you need. You may also want to try widening your search parameters.`}
            </p>
          </div>
        ) : (
          <>
            {!isCarrotRxCompany && (
              <div className="db dn-l f6 pb4">
                <ArrowLink to="/providerfinder/whatsimportant">{l`whatsImportant`}</ArrowLink>
              </div>
            )}
            <MultiColumnLayout>
              <Subsection country={country} countryProviderData={countryProviderData} hasMargin={false} columnSpan />
            </MultiColumnLayout>
          </>
        )}
      </div>
    </div>
  )
}

let ProviderFinder = ({ countryCode }) => (
  <ProviderFinderLayout
    headerText={l`providerFinder`}
    main={<Main countryCode={countryCode} />}
    sideBar={<ProviderFinderSideBar />}
  />
)

ProviderFinder.propTypes = {
  countryCode: PropTypes.string.isRequired
}

const mapStateToProps = (state) => ({
  countryCode: getCountryCode(state)
})

ProviderFinder = connect(mapStateToProps, undefined)(ProviderFinder)

export default ProviderFinder
